export default "__VITE_ASSET__CHxeUVnG__"